import utility from './utility'

const lotteries = {
    init: function() {
        const comboContainer = document.getElementById("combo--container");
        if (!comboContainer) {
            return;
        }

        [...comboContainer.querySelectorAll("a")].map(el => {
            el.onclick = () => {
                utility.disableButton(el);
            };
        });

        [...comboContainer.querySelectorAll(".info-icon")].map(el => {
            el.onclick = () => {
                const data = el.parentElement.nextElementSibling;
                if (data) {
                    if (data.classList.contains("active")) {
                        data.style.maxHeight = 0;
                    }
                    else {
                        data.style.maxHeight = `${data.scrollHeight}px`;
                    }
                    utility.toggleClass(data, "active");
                }
            };
        });
        
        [...comboContainer.querySelectorAll("button")].map(el => {
            el.onclick = (event) => {
                const button = event.currentTarget; 
                const form = event.currentTarget.closest("form");
                utility.disableButton(button);
                utility.ajaxRequest({
                    url: "/api/web/lottery/combo-play",
                    method: "POST",
                    data: utility.getFormData(form),
                    responseType: "text",
                    success: function (e) {
                        const result = JSON.parse(e.target.responseText);
                        if (result.success) {
                            window.location.href = "/checkout";
                        }
                        else {
                            utility.enableButton(button);
                            const errorMessage = result.error ? result.error : "An unknown error occurred.";
                            utility.showNotificationPopup({
                                title: "Error",
                                content: errorMessage
                            });
                        }
                    },
                    error: function () {
                        utility.enableButton(button);
                        utility.showNotificationPopup({
                            title: "Error",
                            content: "An unknown error has occurred"
                        });
                    }
                });
            }
        });
    }
};

export default lotteries;


// WEBPACK FOOTER //
// ./assets/src/js/classes/lotteries.js